export default async function useApi(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  body?: any,
  isForm?: boolean,
  hasNoAuth?: boolean,
  silent?: boolean
) {
  const { apiBaseUrl } = useAppConfig()
  const { user, contact, logout } = useUserStore()
  const isContactUrl = url.startsWith('css/') || url.startsWith('public/')
  const runtimeConfig = useRuntimeConfig()
  const tenantId = runtimeConfig.public.PFLEGERING_TENANT_ID
  const wasAuthenticated = !hasNoAuth && Boolean(isContactUrl ? contact?.token : user?.api_token)
  try {
    const response = await $fetch<any>(`${apiBaseUrl}${url}`, {
      method,
      headers: {
        accept: 'application/json',
        'X-Tenant': `${tenantId}`,
        ...(hasNoAuth
          ? {}
          : { Authorization: `Bearer ${isContactUrl ? contact.token : user.api_token}` }),
        ...(body && !isForm ? { 'Content-Type': 'application/json' } : {})
      },
      body: isForm ? body : JSON.stringify(body)
    })

    return response
  } catch (error: any) {
    if (!silent) {
      const errorData = error
      const errorFields = errorData?.data?.errors || { message: [errorData?.data?.message ?? ''] }

      Object.keys(errorFields).forEach((field) => {
        toast.value?.add({
          severity: 'error',
          detail: errorFields?.[field]?.[0] || 'Unknown error',
          life: TOAST_LIFE_TIME_MS
        })
      })
    }

    if (error.statusCode === 401 && wasAuthenticated) {
      logout()
    }

    return {}
  }
}
